import type { QueryResult } from 'utils/api'

import { useApiQuery } from '../useApiQuery'

export type AuditAction = 'CREATED' | 'MODIFIED' | 'DELETED' | 'OTHER'
export type AuditSource = 'MANUAL' | 'WEBHOOK' | 'SYSTEM'

export interface AuditUser {
  id: string
  name: string | null
  email: string
}

export interface Audit {
  id: string
  userId: string
  user: AuditUser
  action: AuditAction
  source: AuditSource
  contactId: string | null
  contactGroupId: string | null
  templateId: string | null
  scheduledCommunicationId: string | null
  scheduleId: string | null
  notes: string | null
  metadata: Record<string, unknown>
  createdAt: string
}

export interface AuditsParams {
  userId?: string
  action?: AuditAction
  source?: AuditSource
  skip?: number
  take?: number
}

interface AuditsResponse {
  rows: Audit[]
  total: number
}

export function useAudits(params: AuditsParams = {}): QueryResult<AuditsResponse> {
  const query = new URLSearchParams()
  if (params.userId) {
    query.set('userId', params.userId)
  }
  if (params.action) {
    query.set('action', params.action)
  }
  if (params.source) {
    query.set('source', params.source)
  }
  if (params.skip !== undefined) {
    query.set('skip', String(params.skip))
  }
  if (params.take !== undefined) {
    query.set('take', String(params.take))
  }
  const suffix = query.toString() ? `?${query.toString()}` : ''
  return useApiQuery<AuditsResponse>(`/api/audits${suffix}`)
}

export function useAudit(id: string | null): QueryResult<Audit> {
  return useApiQuery<Audit>(id ? `/api/audits/${id}` : null)
}
